export default angular
  .module("ScriptContentCtrl", [
    "angularUtils.directives.dirPagination",
    "ui.bootstrap",
  ])
  .controller("ScriptContentController", [
    "$scope",
    "$timeout",
    "$location",
    "$state",
    "$modal",
    "$stateParams",
    "$http",
    "$rootScope",
    "$translate",
    "Scripts",
    "Message",
    "System",
    "ScriptLoading",
    "modal",
    "Flash",
    function (
      $scope,
      $timeout,
      $location,
      $state,
      $modal,
      $stateParams,
      $http,
      $rootScope,
      $translate,
      Scripts,
      Message,
      System,
      ScriptLoading,
      modal,
      Flash,
    ) {
      System.loadInterventions((data) => {
        $scope.interventions = data;
      });

      const scriptId = $stateParams.scriptid;
      const loggedUser = $scope.loggedUser;
      const modifiedReturningMessage = new Map();
      $scope.reminderToggle = {
        visibility: false,
        label: "Show deactivated",
      };
      // $scope.scriptmeta.CODES_SPLITTED = ($scope.scriptmeta.KEYWORDS || "")
      //       .split(";")
      $scope.loadEvidenceTags = function (query) {
        return [
          "AA-P0",
          "ADA001-P1",
          "ADA001-P2",
          "ADA001-P3",
          "ADA001-P4",
          "BAB-L2",
          "BAB-P1",
          "BAB-P2",
          "BAB-P3",
          "BAB-P4",
          "BAB-P4A",
          "BAB-P4B",
          "EDA-P2",
          "EDA-P3",
          "EDA-P4",
          "EEA-L2",
          "EEA-L3",
          "EEA-L4",
          "EEA-P4",
          "HBA-L2",
          "1155-P2",
          "1881-P2",
          "3635",
          "3635-P3",
          "4594-P2",
          "6466",
          "LAD-P4",
          "ADB001-P1",
          "ADB001-P2",
          "ADB001-P3",
          "ADB001-P4",
          "KA-L2",
          "KA-L3",
        ].filter((tag) => tag.toLowerCase().indexOf(query.toLowerCase()) !== -1);
      };
      $scope.messageTextCodes = [];

      $scope.toggleReminder = () => {
        $scope.reminderToggle.visibility = !$scope.reminderToggle.visibility;
        $scope.reminderToggle.label = $scope.reminderToggle.visibility
          ? "Hide deactivated"
          : "Show deactivated";
      };

      const loadReturningMessages = (language, callback) => {
        Scripts.loadScriptReturningMessagesByID(scriptId, language, callback);
      };

      const updateReturningMessageList = () => {
        loadReturningMessages("en", (dataArrayEn, statusEn) => {
          loadReturningMessages(loggedUser.language, (dataArrayLang, statusLang) => {
            if (statusEn === 200 && statusLang === 200) {
              $scope.scriptReturnMessages = dataArrayEn
                .map((el, i) => {
                  el.NAME_LANG = dataArrayLang[i].NAME;
                  el.SHORT_MESSAGE_LANG = dataArrayLang[i].SHORT_MESSAGE;
                  el.LONG_MESSAGE_LANG = dataArrayLang[i].LONG_MESSAGE;
                  el.NURSE_MESSAGE_LANG = dataArrayLang[i].NURSE_MESSAGE;
                  el.PATIENT_MESSAGE_LANG = dataArrayLang[i].PATIENT_MESSAGE;
                  el.ID_LANG = dataArrayLang[i].ID;
                  el.ORIGINAL_MESSAGE = el.SHORT_MESSAGE || el.SHORT_MESSAGE_LANG;
                  el.SHOWDETAILS = true;

                  return el;
                });
                $scope.scriptReturnMessages = $scope.scriptReturnMessages.map(({ CODES, ...rest }) => {
                  return {
                    ...rest,
                    CODES: CODES ? CODES.split(",").map(code => ({ text: code })): null
                  }
                });
              $scope.selected.scriptReturnMessage = $scope.scriptReturnMessages.find(
                ({ MESSAGE_ID }) => $scope.savedScriptResponseMessageId === MESSAGE_ID,
              );
              ScriptLoading.markContentLogicResourceLoaded("returningMessagesEN");
              ScriptLoading.markContentLogicResourceLoaded("returningMessagesUserLang");
            }
          });
        });
      };

      /**
       * Stores modified returning message into map structure
       * @param m as returning message
       * @param c as changed field
       */
      $scope.editReturningMessage = (m, c) => {
        switch (c) {
          case "messageAny":
            modifiedReturningMessage.set(`${m.MESSAGE_ID}`, m);
            break;
          case "messageAnyLang":
            modifiedReturningMessage.set(`${m.MESSAGE_ID}:${$scope.language}`, {
              NAME: m.NAME_LANG,
              SHORT_MESSAGE: m.SHORT_MESSAGE_LANG,
              LONG_MESSAGE: m.LONG_MESSAGE_LANG,
              NURSE_MESSAGE: m.NURSE_MESSAGE_LANG,
              PATIENT_MESSAGE: m.PATIENT_MESSAGE_LANG,
              ID: m.ID_LANG,
              LANG: $scope.language,
              SCRIPT_ID: m.SCRIPT_ID,
              MESSAGE_ID: m.MESSAGE_ID,
            });
            break;
          default:
            break;
        }
        $rootScope.changedFields.set("returningMessage", true);
      };

      const updateReturningMessage = (clearChange) => {
        modifiedReturningMessage
          .forEach((message, key) =>
            Scripts.updateScriptAnyMessage(message, () => modifiedReturningMessage.delete(key)));
        clearChange();
      };

      // Load messages initially, and on every language change
      $rootScope.$watch("loggedUser", () => {
        updateReturningMessageList();
      }, true);

      $scope.reactivateReturnMessage = (message) => {
        const isSameMessageNumberAlreadyActivated = $scope.scriptReturnMessages
          .some(el => el.MESSAGE_NUMBER === message.MESSAGE_NUMBER && el.ID !== message.ID);

        if (isSameMessageNumberAlreadyActivated) {
          Flash.create(
            "danger",
            "Unable to reactivate the selected message. The message with the same message number is already activated.",
            "basicAlert",
          );
          return;
        }

        Scripts.reactivateScriptMessage(message, updateReturningMessageList);
      };

      // open modal to edit returning message relations
      $scope.openRelationsModal = function (returnMessage) {
        const modalInstance = $modal.open({
          animation: true,
          size: "lg",
          templateUrl: "view/modal/editRelations.html",
          backdrop: "static",
          controller: "ModifyRelationsController",
          resolve: {
            relationsData() {
              return returnMessage;
            },
          },
        });
        modalInstance.result.then(() => {
        });
      };

      // open modal to edit selected phrase alias
      $scope.openCodeAliasModal = function (codeAlias, template, controller) {
        const modalInstance = $modal.open({
          animation: true,
          size: "lg",
          templateUrl: `view/modal/${template}CodeAlias.html`,
          backdrop: "static",
          controller: `${controller}CodeAliasController`,
          resolve: {
            codeAliasData() {
              return codeAlias;
            },
          },
        });
        modalInstance.result.then(() => {
          Scripts.loadScriptCodeAliasesByID($rootScope.pageID, (data) => {
            $scope.scriptcodealias = data;
            for (let i = 0; $scope.scriptcodealias.length > i; i++) {
              (function (cntr) {
                $scope.scriptcodealias[cntr].ORIGINAL_NAME =
                  $scope.scriptcodealias[cntr].NAME;
                System.loadAliasTestingNames(
                  $scope.scriptcodealias[cntr].SYS_ID,
                  $rootScope.loggedUser.language,
                  (names) => {
                    $scope.scriptcodealias[cntr].testingnames = names;
                  },
                );
              }(i));
            }
          });
        });
      };

      // open modal to edit selected phrase alias
      $scope.openPhraseAliasModal = function (phrasealias) {
        const modalInstance = $modal.open({
          animation: true,
          size: "lg",
          templateUrl: "view/modal/editPhraseAlias.html",
          backdrop: "static",
          controller: "ModifyPhraseAliasController",
          resolve: {
            phrasealiasData() {
              return phrasealias;
            },
          },
        });
        modalInstance.result.then(() => {
          Scripts.loadScriptPhraseAliasesByID(
            $scope.scriptmeta.ID,
            $rootScope.loggedUser.language,
            (data) => {
              $scope.scriptphrasealias = data;
            },
          );
        });
      };

      $scope.openTranslationModal = function (MESSAGE_ID, FIELDCONFIG) {
        const modalInstance = $modal.open({
          animation: true,
          size: "lg",
          templateUrl: "view/modal/editMessageTranslation.html",
          backdrop: "static",
          controller: "ModifyMessageTranslationController",
          resolve: {
            messageData() {
              return {
                SCRIPT_ID: $scope.scriptmeta.ID,
                MESSAGE_ID,
                ...FIELDCONFIG,
              };
            },
          },
        });
        modalInstance.result.then(updateReturningMessageList);
      };

      $scope.addReturningMessage = function () {
        const newReturningMessage = {};
        newReturningMessage.SCRIPT_ID = $scope.scriptmeta.ID;
        Scripts.updateScriptMessage(newReturningMessage, updateReturningMessageList);
      };

      $scope.openDeleteReturnMessageModal = function (returnMessage) {
        modal.openDelete(returnMessage.SHORT_MESSAGE, "Return Message").result.then(() => {
          Scripts.deleteScriptMessage(returnMessage, updateReturningMessageList);
        });
      };

      $scope.addPhraseAlias = function () {
        $scope.scriptphrasealias.push({ // TODO: More / better defaults?
          LANG: $scope.language,
        });
        $scope.changedField("phrase_alias");
      };

      $scope.removePhraseAlias = function (id, aliasKey) {
        if (!id) {
          // The item has not been saved yet, just remove it.
          $scope.scriptphrasealias = $scope.scriptphrasealias.filter((f, k) => k !== aliasKey);
          return;
        }

        modal.openDelete(id, "phrase alias from the script").result.then(() => {
          Scripts.deleteScriptPhraseAlias(id, () => {
            $scope.scriptphrasealias = $scope.scriptphrasealias.filter(f => f.ID !== id);
          });
        });
      };

      $scope.addFlowItem = function () {
        $scope.scriptflows.push({ // TODO: More / better defaults?
          ROW_NUMBER: $scope.scriptflows.length + 1,
          MESSAGE_ID: null,
        });
        $scope.changedField("flow");
      };

      $scope.removeFlowItem = function (id, flowKey) {
        if (!id) {
          // The item has not been saved yet, just remove it.
          $scope.scriptflows = $scope.scriptflows.filter((f, k) => k !== flowKey);
          return;
        }

        modal.openDelete(id, "Flow Item from the script").result.then(() => {
          Scripts.deleteScriptFlowItem(id, () => {
            $scope.scriptflows = $scope.scriptflows.filter(f => f.ID !== id);
          });
        });
      };

      $scope.returnMessageToString = (returnMessage) => {
        // eslint-disable-next-line no-confusing-arrow
        const shorten = text => text.length > 50 ? `${text.substring(0, 47)}...` : text;

        return `#${returnMessage.MESSAGE_NUMBER} - ${shorten(returnMessage.SHORT_MESSAGE || "")}`;
      };

      // Save changes to script. User clicked save changes -button in left menu
      // after modifying script.
      const scriptListener = $rootScope.$on("saveScriptChanges", () => {
        let dataCntr = 0;
        function dataChanged() {
          if (dataCntr < $scope.scriptReturnMessages.length) {
            if ($rootScope.changedFields.get("messageDATA")) {
              Scripts.updateScriptMessage(
                $scope.scriptReturnMessages[dataCntr],
                () => {
                  dataCntr++;
                  dataChanged();
                },
              );
            } else {
              dataCntr++;
              dataChanged();
            }
          } else {
            Scripts.markSaved("messageDATA");
          }
        }

        let aliasCntr = 0;

        function aliasChanged() {
          if (aliasCntr < $scope.scriptcodealias.length) {
            if ($rootScope.changedFields.get("codealias")) {
              Scripts.updateScriptCodeAlias(
                $scope.scriptcodealias[aliasCntr],
                () => {
                  aliasCntr++;
                  aliasChanged();
                },
              );
            } else {
              aliasCntr++;
              aliasChanged();
            }
          } else {
            Scripts.markSaved("codealias");
          }
        }

        function phraseAliasChanged() {
          Scripts.updateScriptPhraseAliases($scope.scriptphrasealias, (data, status) => {
            if (status === 200) {
              $scope.scriptphrasealias = data.items;
              Scripts.markSaved("phrase_alias");
            }
          });
        }

        function flowChanged() {
          Scripts.updateScriptFlow($scope.scriptflows, (data, status) => {
            if (status === 200) {
              $scope.scriptflows = data.items;
              Scripts.markSaved("flow");
            }
          });
        }

        function responseMessageChanged() {
          console.log($scope.selected.scriptReturnMessage);
          const messageId = $scope.selected.scriptReturnMessage.MESSAGE_ID;
          Scripts.updateScriptResponseMessage(scriptId, messageId, (status) => {
            if (status === 200) {
              Scripts.markSaved("responseMessage");
            }
          });
        }
        if ($rootScope.changedFields.get("responseMessage")) {
          responseMessageChanged();
        }
        if ($rootScope.changedFields.get("returningMessage")) {
          updateReturningMessage(() => Scripts.markSaved("returningMessage"));
        }
        if ($rootScope.changedFields.get("messageDATA")) {
          dataChanged();
        }
        if ($rootScope.changedFields.get("codealias")) {
          aliasChanged();
        }
        if ($rootScope.changedFields.get("flow")) {
          flowChanged();
        }
        if ($rootScope.changedFields.get("phrase_alias")) {
          phraseAliasChanged();
        }
      });
      $scope.$on("$destroy", scriptListener);
      $scope.selected = {
        scriptReturnMessage: null,
      };
      Scripts.loadScriptResponseMessageById(scriptId, (data) => {
        $scope.savedScriptResponseMessageId = data[0] ? data[0].MESSAGE_ID : null;
      });
    },
  ]);
